import { render, staticRenderFns } from "./MediaLibraryModalCard.vue?vue&type=template&id=237a59bb&scoped=true&"
import script from "./MediaLibraryModalCard.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryModalCard.vue?vue&type=script&lang=js&"
import style0 from "./MediaLibraryModalCard.vue?vue&type=style&index=0&id=237a59bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a59bb",
  null
  
)

export default component.exports